"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var token_1 = require("./token");
Object.defineProperty(exports, "jsonSchemaToView", { enumerable: true, get: function () { return token_1.default; } });
//# sourceMappingURL=index.js.map